import _ from 'lodash'
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TicketsSelector from './TicketsSelector';
import { MAX_TICKETS_IN_ORDER } from '../../../config'
import { ChosenTickets } from '../ChosenTickets';

class TicketSelectorList extends Component {
    render() {
        return (
            <React.Fragment>
                {this.getSortedTickets().map(ticketSet => {
                    var maxCount = Math.min(MAX_TICKETS_IN_ORDER, ticketSet.amount_available);
                    return (
                        <TicketsSelector key={ticketSet.name}
                            comment={this.props.performance.name}
                            onChange={(tickets) => this.handleTicketsChange(tickets)}
                            increaseAllowed={this.props.chosenTickets.getCount() < maxCount}
                            maxCount={maxCount}
                            ticketSet={ticketSet}
                            chosenTickets={this.props.chosenTickets.getByName(ticketSet.name)} />
                    )
                })}
            </React.Fragment>
        );
    }

    getSortedTickets = () => {

        const ticketsSortedByPrice = _.sortBy(
            this.props.tickets,
            [(set) => Number.parseFloat(set.price), 'name']
        )

        const availableTickets = ticketsSortedByPrice.filter(
            ticket => ticket.amount_available > 0
        )

        const unavailableTickets = ticketsSortedByPrice.filter(
            ticket => ticket.amount_available <= 0
        )

        return availableTickets.concat(unavailableTickets);

    }

    handleTicketsChange = (tickets) => {
        const newChosenTickets = this.props.chosenTickets.addImmutably(tickets)
        this.props.onChange(newChosenTickets);
    }
}

TicketSelectorList.propTypes = {
    tickets: PropTypes.array.isRequired,
    chosenTickets: PropTypes.instanceOf(ChosenTickets).isRequired,
    onChange: PropTypes.func
}

export default TicketSelectorList;
